import { ICONS } from '@ui/icons/types';

export enum ESessionFeatures {
  CHAT = 'chat',
  QA = 'qa',
  CAPTIONS = 'captions',
  REACTIONS = 'reactions',
  RESOURCES = 'resources',
  PRODUCTS = 'products',
  COURSES = 'courses',
}

export const SessionFeatureLabels: Record<ESessionFeatures, string> = {
  [ESessionFeatures.CHAT]: 'Chat',
  [ESessionFeatures.QA]: 'Q&A',
  [ESessionFeatures.CAPTIONS]: 'Captions',
  [ESessionFeatures.REACTIONS]: 'Reactions',
  [ESessionFeatures.RESOURCES]: 'Resources',
  [ESessionFeatures.PRODUCTS]: 'Products',
  [ESessionFeatures.COURSES]: 'Courses',
};

export type TSessionFeatureListItem = {
  label: string;
  value: ESessionFeatures;
  icon: string;
};

/** some features can be toggled on/off in the creation flow because they are on/off settings, some cannot because they require additional data during the create flow  */
export const ToggleableSessionFeatures: Record<ESessionFeatures, boolean> = {
  [ESessionFeatures.CHAT]: true,
  [ESessionFeatures.CAPTIONS]: true,
  /**
    Note: we can set QA to true and simply create a new module during the add new session process,
    however it gets messy during the "edit" session flow because this feature doesn't have an on/off toggle.
    Question modules need to be created/deleted, which if deleted, will not be able to be added back and all the user's
    customizations on that module will be lost. If product decide this is ok, then we can set this to true.
    Note: if toggling QA to true, the QA module creation is already implemented in the create session flow (see `<SessionFeatures />` in `add-new-session-modal.tsx`),
    however, the delete/re-create module flow is not implemented yet in the edit session flow (see `<SessionFeatures />` component in `project-session.tsx`)
  */
  [ESessionFeatures.QA]: false,
  [ESessionFeatures.REACTIONS]: false,
  [ESessionFeatures.RESOURCES]: false,
  [ESessionFeatures.PRODUCTS]: false,
  [ESessionFeatures.COURSES]: true,
};

export const EventDefaultFeatures: TSessionFeatureListItem[] = [
  { label: SessionFeatureLabels[ESessionFeatures.CHAT], value: ESessionFeatures.CHAT, icon: ICONS.CHAT_DIALOG },
  { label: SessionFeatureLabels[ESessionFeatures.QA], value: ESessionFeatures.QA, icon: ICONS.QUESTION_FILLED },
  {
    label: SessionFeatureLabels[ESessionFeatures.CAPTIONS],
    value: ESessionFeatures.CAPTIONS,
    icon: ICONS.CAPTIONS,
  },
  {
    label: SessionFeatureLabels[ESessionFeatures.REACTIONS],
    value: ESessionFeatures.REACTIONS,
    icon: ICONS.REACTION_ADD,
  },
  {
    label: SessionFeatureLabels[ESessionFeatures.RESOURCES],
    value: ESessionFeatures.RESOURCES,
    icon: ICONS.NOTES,
  },
  {
    label: SessionFeatureLabels[ESessionFeatures.PRODUCTS],
    value: ESessionFeatures.PRODUCTS,
    icon: ICONS.PRODUCT,
  },
];

export const TownhallDefaultFeatures: TSessionFeatureListItem[] = [
  { label: SessionFeatureLabels[ESessionFeatures.CHAT], value: ESessionFeatures.CHAT, icon: ICONS.CHAT_DIALOG },
  { label: SessionFeatureLabels[ESessionFeatures.QA], value: ESessionFeatures.QA, icon: ICONS.QUESTION_FILLED },
  {
    label: SessionFeatureLabels[ESessionFeatures.CAPTIONS],
    value: ESessionFeatures.CAPTIONS,
    icon: ICONS.CAPTIONS,
  },
  {
    label: SessionFeatureLabels[ESessionFeatures.REACTIONS],
    value: ESessionFeatures.REACTIONS,
    icon: ICONS.REACTION_ADD,
  },
  {
    label: SessionFeatureLabels[ESessionFeatures.RESOURCES],
    value: ESessionFeatures.RESOURCES,
    icon: ICONS.NOTES,
  },
];

export const WebinarDefaultFeatures: TSessionFeatureListItem[] = [
  { label: SessionFeatureLabels[ESessionFeatures.CHAT], value: ESessionFeatures.CHAT, icon: ICONS.CHAT_DIALOG },
  { label: SessionFeatureLabels[ESessionFeatures.QA], value: ESessionFeatures.QA, icon: ICONS.QUESTION_FILLED },
  {
    label: SessionFeatureLabels[ESessionFeatures.COURSES],
    value: ESessionFeatures.COURSES,
    icon: ICONS.EDUCATION_MORTARBOARD,
  },
  {
    label: SessionFeatureLabels[ESessionFeatures.CAPTIONS],
    value: ESessionFeatures.CAPTIONS,
    icon: ICONS.CAPTIONS,
  },
  {
    label: SessionFeatureLabels[ESessionFeatures.REACTIONS],
    value: ESessionFeatures.REACTIONS,
    icon: ICONS.REACTION_ADD,
  },
];

export const OnDemandDefaultFeatures: TSessionFeatureListItem[] = [];
